import 'signer-app/authentication/arkose-global.d.ts';
import * as Sentry from '@sentry/browser';

export const loadArkoseCdnScript = (
  publicApiKey: string,
  onArkoseLoad: (e: ArkoseEnforcement) => void,
) => {
  const script = document.createElement('script');
  script.src = `//dropbox-api.arkoselabs.com/v2/${publicApiKey}/api.js`;
  script.async = true;
  script.defer = true;
  script.onerror = () => {
    Sentry.captureException('Unable to fetch api.js from Arkose', {
      tags: {
        src: script.src,
      },
    });
  };
  window.onArkoseLoad = onArkoseLoad;
  script.setAttribute('data-callback', 'onArkoseLoad');
  document.body.appendChild(script);
};
